import { RastreioCancerPerguntaDbEnum, RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

import { MamografiaPerguntaField } from '../model-mamografia'

export const MAMOGRAFIA_PERGUNTAS_ANAMNESE: Partial<Record<RastreioCancerPerguntaDbEnum, string>> = {
  [MamografiaPerguntaField.noduloCaroco]: 'Tem nódulo ou caroço na mama',
  [MamografiaPerguntaField.riscoCancerMama]: 'Apresenta risco elevado para câncer de mama',
  [MamografiaPerguntaField.mamasExaminadas]:
    'Antes desta consulta, teve suas mamas examinadas por um profissional de saúde?',
  [MamografiaPerguntaField.fezMamografia]: 'Fez mamografia alguma vez',
  [MamografiaPerguntaField.anoUltimaMamografia]: 'Quando fez a última mamografia',
  [MamografiaPerguntaField.fezRadioterapia]: 'Fez radioterapia na mama ou no plastão',
  [MamografiaPerguntaField.radioterapiaLocalizacao]: 'Radioterapia - Localização',
  [MamografiaPerguntaField.anoRadioterapiaMamaDireita]: 'Ano da radioterapia na mama direita',
  [MamografiaPerguntaField.anoRadioterapiaMamaEsquerda]: 'Ano da radioterapia na mama esquerda',
  [MamografiaPerguntaField.fezCirurgiaMama]: 'Fez cirurgia na mama',
}

export const mamasExaminadasOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.SIM, label: 'Sim' },
  {
    value: RastreioCancerPerguntaOpcaoEnum.NUNCA_FORAM_EXAMINADAS_ANTERIORMENTE,
    label: 'Nunca foram examinadas anteriormente',
  },
  { value: RastreioCancerPerguntaOpcaoEnum.NAO_SABE, label: 'Não sabe' },
]

export const noduloCarocoOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.SIM_MAMA_DIREITA, label: 'Sim, mama direita' },
  { value: RastreioCancerPerguntaOpcaoEnum.SIM_MAMA_ESQUERDA, label: 'Sim, mama esquerda' },
  { value: RastreioCancerPerguntaOpcaoEnum.NAO, label: 'Não' },
]

export const localizacaoRadioterapiaOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.DIREITA, label: 'Direita' },
  { value: RastreioCancerPerguntaOpcaoEnum.ESQUERDA, label: 'Esquerda' },
  { value: RastreioCancerPerguntaOpcaoEnum.AMBAS, label: 'Ambas' },
]

export const anamneseCirurgiaTableOptions = [
  {
    label: 'Biopsia cirúrgica incisional',
    valueDireita: MamografiaPerguntaField.biopsiaCirurgicaIncisionalDireita,
    valueEsquerda: MamografiaPerguntaField.biopsiaCirurgicaIncisionalEsquerda,
  },
  {
    label: 'Biopsia cirúrgica excisional',
    valueDireita: MamografiaPerguntaField.biopsiaCirurgicaExcisionalDireita,
    valueEsquerda: MamografiaPerguntaField.biopsiaCirurgicaExcisionalEsquerda,
  },
  {
    label: 'Centralectomia',
    valueDireita: MamografiaPerguntaField.centralectomiaDireita,
    valueEsquerda: MamografiaPerguntaField.centralectomiaEsquerda,
  },
  {
    label: 'Segmentectomia',
    valueDireita: MamografiaPerguntaField.segmentectomiaDireita,
    valueEsquerda: MamografiaPerguntaField.segmentectomiaEsquerda,
  },
  {
    label: 'Dutectomia',
    valueDireita: MamografiaPerguntaField.dutectomiaDireita,
    valueEsquerda: MamografiaPerguntaField.dutectomiaEsquerda,
  },
  {
    label: 'Mastectomia',
    valueDireita: MamografiaPerguntaField.mastectomiaDireita,
    valueEsquerda: MamografiaPerguntaField.mastectomiaEsquerda,
  },
  {
    label: 'Mastectomia poupadora de pele',
    valueDireita: MamografiaPerguntaField.mastectomiaPoupadoraPeleDireita,
    valueEsquerda: MamografiaPerguntaField.mastectomiaPoupadoraPeleEsquerda,
  },
  {
    label: 'Mastectomia poupadora de pele e complexo aréolo-papilar',
    valueDireita: MamografiaPerguntaField.mastectomiaPoupadoraPeleComplexoDireita,
    valueEsquerda: MamografiaPerguntaField.mastectomiaPoupadoraPeleComplexoEsquerda,
  },
  {
    label: 'Linfadenectomia axilar',
    valueDireita: MamografiaPerguntaField.linfadenectomiaAxilarDireita,
    valueEsquerda: MamografiaPerguntaField.linfadenectomiaAxilarEsquerda,
  },
  {
    label: 'Biopsia de linfonodo sentinela',
    valueDireita: MamografiaPerguntaField.biopsiaLinfonodoSentinelaDireita,
    valueEsquerda: MamografiaPerguntaField.biopsiaLinfonodoSentinelaEsquerda,
  },
  {
    label: 'Reconstrução mamária',
    valueDireita: MamografiaPerguntaField.reconstrucaoMamariaDireita,
    valueEsquerda: MamografiaPerguntaField.reconstrucaoMamariaEsquerda,
  },
  {
    label: 'Mastoplastia redutora',
    valueDireita: MamografiaPerguntaField.mastoplastiaRedutoraDireita,
    valueEsquerda: MamografiaPerguntaField.mastoplastiaRedutoraEsquerda,
  },
  {
    label: 'Inclusão de implantes',
    valueDireita: MamografiaPerguntaField.inclusaoImplantesDireita,
    valueEsquerda: MamografiaPerguntaField.inclusaoImplantesEsquerda,
  },
]

export const cirurgiaAnoFields = anamneseCirurgiaTableOptions.flatMap(({ valueDireita, valueEsquerda }) => [
  valueDireita,
  valueEsquerda,
])
